import md5 from 'md5';
const checkKeys = ['id', 'record_id', 'video_id', 'biz_id'];
export const getUrlParams = (url) => {
  const urlStr = url.split('?')[1];
  const obj = {};
  if (urlStr) {
    const paramsArr = urlStr.split('&');
    for (let i = 0, len = paramsArr.length; i < len; i++) {
      const arr = paramsArr[i].split('=');
      obj[arr[0]] = arr[1];
    }
  }
  return obj;
};
export const encryptValue = (key, value) => {
  if (checkKeys.includes(key)) {
    // eslint-disable-next-line no-param-reassign
    value = md5(value);
  }
  return value;
};
export const encryptUrl = (url) => {
  const queryObj = getUrlParams(url);
  Object.keys(queryObj).forEach((key) => {
    // eslint-disable-next-line no-param-reassign
    url = url.replace(queryObj[key], encryptValue(key, queryObj[key]));
  });
  return url;
};
// 递归加密需要处理的key值，同时兼容data传json的形式, fetch传字符串，xhr传对象
export const deepEncrypt = (data) => {
  let needJson = false;
  try {
    if (data) {
      if (typeof data === 'string') {
        data = JSON.parse(data);
        needJson = true;
      }
      Object.keys(data).forEach((key) => {
        if (typeof data[key] === 'object') {
          return deepEncrypt(data[key]);// 递归判断
        }
        // eslint-disable-next-line no-param-reassign
        data[key] = encryptValue(key, data[key]);
      });
    }
    if (needJson) {
      data = JSON.stringify(data);// 保留原有上传格式
    }
  } catch (e) {
    // console.log(e);
  }
  return data;
};
